import React from 'react';
import { TbordOneToneIcon } from 'components/NudosComponents/BordOneToneIcon/BordOneToneIcon.types';
import { IProductList } from 'types/orders';

export enum COLUMN_TYPE {
  // Finance columns
  WARNING = 'warning',
  DEFAULT = 'default',
  SUCCESS = 'success',
  // Operation columns
  CONFIRMED = 'confirmed',
  PREPARATION = 'preparation',
  TRANSIT_TO_WAREHOUSE = 'transitToWarehouse',
  IN_WAREHOUSE = 'inWarehouse',
  TRANSIT_TO_DESTINATION = 'transitToDestination',
  DELIVERED = 'delivered'
}

export interface ITrelloColumn {
  title: string;
  subtitle: string;
  variantIcon: TbordOneToneIcon;
  items: IProductList[];
  isLoading: boolean;
  renderItem?: (item: IProductList) => React.ReactNode;
  columnType?: COLUMN_TYPE;
  isLoadingMoreItems?: boolean;
  hasMoreItems?: boolean;
  onLoadMore?: () => void;
  trelloColumnHeaderCustomClassName?: string;
}
